import React, { Component } from "react";
import Header from './Header'
import {GetUser, RemoveUser} from '../util/Helper';
import { useAuth0 } from "@auth0/auth0-react";

const UserSettings = () => {
  const { logout } = useAuth0();
  const account = GetUser();

  function logoutUser(){
    RemoveUser();
    logout({
      returnTo:window.location.hostname.indexOf('localhost') > -1 ? 'http://localhost:3000/' : 'https://dev-binderdrop.azurewebsites.net/'
    })
  }

  return (
    <div>
    <Header title="User Settings"/>
    {account &&
    <div className="card fullTable">
      <span className="fieldDescription">Email</span>
      <span type="text" placeholder="Set value" className="fieldInput" >{account.email}</span>
      <span className="fieldDescription">Name</span>
      <input type="text" placeholder="Set value" className="fieldInput" value={ account.name }/>
      <button id="usLogoutButton" className="pillButton"  onClick={() => logoutUser()}> Log Out</button>
    </div>
    }
  </div>
  
  ) 
}

 
export default UserSettings;
